module.exports = __webpack_public_path__ + "static/media/4431.1cf99154.jpg";